import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { SettingsItemEnum } from "../../../../assets/utils/data/items";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { BodyDiv } from "../../../../components/components-style";
import {
  MediumText,
  NotificationText,
} from "../../../../components/typography";
import { Button } from "../../../../components/ui/button";
import Input from "../../../../components/ui/inputs";
import { Block } from "../../main";
import { UserImage } from "./profile-tab";
import userImage from "../../../../assets/images/user-image.png";
import { useAuthValidation } from "../../../../assets/utils/hooks/useAuthValidation";
import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

type ProfileOutletContext = {
  setLoaderState: React.Dispatch<React.SetStateAction<boolean>>;
  isChangedFields: boolean;
  setIsChangedState: React.Dispatch<React.SetStateAction<boolean>>;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  changedFirstName: string;
  setChangedFirstName: React.Dispatch<React.SetStateAction<string>>;
  changedLastName: string;
  setChangedLastName: React.Dispatch<React.SetStateAction<string>>;
  changedPhone: string;
  setChangedPhone: React.Dispatch<React.SetStateAction<string>>;
  submitEdit: () => void;
};

export default function EditProfile() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setLoaderState, isChangedFields, setIsChangedState, firstName, lastName, phone, changedFirstName, setChangedFirstName, changedLastName, setChangedLastName, changedPhone, setChangedPhone, submitEdit } =
    useOutletContext<ProfileOutletContext>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { errors, validate } = useAuthValidation();

  useEffect(() => {
    function isChanged(
      editFirstName: string,
      editLastName: string,
      editPhone: string
    ) {
      if (
        editFirstName !== firstName ||
        editLastName !== lastName ||
        editPhone !== phone
      ) {
        setIsChangedState(true);
      } else {
        setIsChangedState(false);
      }
    }

    isChanged(changedFirstName, changedLastName, changedPhone);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changedFirstName, changedLastName, changedPhone]);

  return (
    <BodyDiv
      className={`${SETTINGS_BODY_DIV} justify-content-between`}
      $isPadding={true}
    >
      <Block
        className={`w-100 d-flex align-items-start justify-content-between`}
      >
        <UserImage $operationItem={SettingsItemEnum.EDIT_PROFILE}>
          <img src={userImage} alt="user-image" />

          <NotificationText>Змінити фото</NotificationText>
        </UserImage>
        <div className="d-flex w-75 flex-column">
          <span className="w-100 d-flex gap-sm-3 flex-sm-row flex-column">
            <Input
              attribute="first-name"
              value={changedFirstName}
              setValue={setChangedFirstName}
              errorText={errors?.firstName!}
              label="Ім'я"
              placeholder="Ім'я"
            />
            <Input
              attribute="last-name"
              value={changedLastName}
              setValue={setChangedLastName}
              errorText={errors?.lastName!}
              label="Прізвище"
              placeholder="Прізвище"
            />
          </span>
          <Input
            attribute="phone"
            value={changedPhone}
            setValue={setChangedPhone}
            errorText={errors?.phone!}
            label="Номер телефону"
            placeholder="Example@gmail.com"
          />
        </div>
      </Block>
      <Block
        className={`w-100 d-flex align-items-center justify-content-center`}
      >
        <Button
          bgcolor={COLORS.secondary1}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          type="large"
          $noactive={!isChangedFields}
          disabled={!isChangedFields}
          width="40%"
          className="d-flex align-items-center gap-2"
          onClick={() => {
            if (isChangedFields) {
              submitEdit();
            }
          }}
        >
          <MediumText>Підтвердити зміни</MediumText>
        </Button>
      </Block>
    </BodyDiv>
  );
}
